import React from "react"
//import I18n from "i18n-js/index.js.erb"
import ModalButtons from "../ModalButtons/ModalButtons"
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner"
import MessagePresenterTabContent from "./MessagePresenterTabContent"
import Tabs from '../Tabs/Tabs';

export default class MessagePresenter extends React.Component {

  constructor(props) {
    // console.log('RTB', this.props);
    super(props);
    this.state = {...this.props}
    this.setActiveTab = this.setActiveTab.bind(this)
    this.onChangeRevertVersion = this.onChangeRevertVersion.bind(this);
  }

  componentDidMount() {
    var self = this
    $(window).on("messageSaved", function () {
      $.ajax({
        type: 'POST',
        url: `/admin/messages/${self.state.message.id}/data`,
      }).done((data) => {
        self.setState({...data})
      })
    });
  }

  render() {
    var self = this;

    var buttons = [
      {
        name: I18n.t('ok'),
        html_attributes: [
            'data-dismiss="modal"'
        ]
      }
    ]

    return (
      <div className="dates-and-times-builder">
        <Tabs tabs={this.tabs()}/>
        <div className="panel panel-form">
          <ModalButtons buttons={buttons} />
          <MessagePresenterTabContent {...this.state} />
        </div>
        <LoadingSpinner show={this.state.loading} />
      </div>
    );
  }


  onChangeRevertVersion() {
    var self = this;
    $.ajax({
      type: 'POST',
      url: `/admin/messages/${this.props.message.id}/version/${this.props.version.id}/revert`,
    }).done((data) => {
      window.parent.$(window.parent).trigger('messageSaved', data);
      this.setState({loading: false});
      if (parent && parent.refresh_data) {
        parent.refresh_data(I18n.t('record_reverted_successfully'));
      }
      if (parent && parent.hide_modal) {
        parent.hide_modal();
      }
    })
  }

  tabs() {
    var tabs = []

    tabs.push({
      tabName: I18n.t('template'),
      targetName: 'template',
      classes: this.state.active_tab === 'template' ? 'active' : null,
      changeHandler: this.setActiveTab,
    })

    tabs.push({
      tabName: I18n.t('history'),
      targetName: 'history',
      classes: this.state.active_tab === 'history' ? 'active' : null,
      changeHandler: this.setActiveTab,
    })

    return tabs;
  };

  setActiveTab(tab) {
    this.setState({
      active_tab: tab
    });
  };
};
